import { stateMachine } from "appworks/state-machine/state-machine";
import { ButtonControl } from "./button-control";

export class SpinControl extends ButtonControl {
    protected onClick(): void {
        stateMachine.skip();
    }
}
